import { RuleDefinition, CreateRuleDTO, RuleCategory, RuleTemplate, TestRuleResponse } from '@core/models/api/api-models';
import { RuleType, RuleConfiguration } from '@core/models/rule-configuration.models';

/**
 * Wizard Step Enum
 */
export enum WizardStep {
  ChooseType = 0,
  BasicInfo = 1,
  Configure = 2,
  Test = 3,
  Review = 4,
  Save = 5
}

/**
 * Rule Builder State Interface (6-Step Wizard)
 */
export interface RuleBuilderState {
  // Step 1: Rule Type Selection
  selectedRuleType: RuleType | null;
  selectedTemplateId: string | null;
  selectedTemplate: RuleTemplate | null;

  // Step 2: Category & Basic Info
  categoryId: string | null;
  ruleName: string;
  ruleDescription: string;
  targetSheets: string[];

  // Step 3: Configuration (dynamic based on rule type)
  configuration: RuleConfiguration | null;

  // Step 4: Test Results
  testFileUploaded: boolean;
  testResults: TestRuleResponse | null;
  testLoading: boolean;

  // Step 5: Review
  reviewed: boolean;

  // Step 6: Save Options
  activateImmediately: boolean;
  saveAsTemplate: boolean;

  // Metadata
  currentStep: WizardStep;
  isEditMode: boolean;
  editRuleId: string | null;
  isDirty: boolean;
  isLoading: boolean;
  isSaving: boolean;
  error: string | null;
  validationErrors: Record<string, string>;

  // Reference Data (loaded once)
  categories: RuleCategory[];
  templates: RuleTemplate[];
  categoriesLoaded: boolean;
  templatesLoaded: boolean;
}

/**
 * Initial Rule Builder State
 */
export const initialRuleBuilderState: RuleBuilderState = {
  // Step 1
  selectedRuleType: null,
  selectedTemplateId: null,
  selectedTemplate: null,

  // Step 2
  categoryId: null,
  ruleName: '',
  ruleDescription: '',
  targetSheets: [],

  // Step 3
  configuration: null,

  // Step 4
  testFileUploaded: false,
  testResults: null,
  testLoading: false,

  // Step 5
  reviewed: false,

  // Step 6
  activateImmediately: true,
  saveAsTemplate: false,

  // Metadata
  currentStep: WizardStep.ChooseType,
  isEditMode: false,
  editRuleId: null,
  isDirty: false,
  isLoading: false,
  isSaving: false,
  error: null,
  validationErrors: {},

  // Reference Data
  categories: [],
  templates: [],
  categoriesLoaded: false,
  templatesLoaded: false
};
